export const SET_INTERACTION_AREA = "SET_INTERACTION_AREA"
export const OPEN_PEOPLE_AREA = "OPEN_PEOPLE_AREA"
export const SET_IS_SUGGEST_WHEN_OPEN = "SET_IS_SUGGEST_WHEN_OPEN"
export const SET_IS_SUGGEST_WHERE_OPEN = "SET_IS_SUGGEST_WHERE_OPEN"
export const SET_IS_DROPDOWN_OPEN = "SET_IS_DROPDOWN_OPEN"
